import * as XLSX from 'xlsx-js-style';
import moment from 'moment';

export const exportAllDataExcel1 = (
  bodyData,
  UserDefaultValues,
  { qtr, requestorUserId },
  logInUser,
  fileName
) => {
  const headerData = {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy: logInUser,
    reportName: 'Quarterly Claim Reconciliation',
    qtr,
    requestorUserId,
  };

const worksheet = [];
const { rightGridData = {} ,leftGridData={}} = bodyData;
const rebateKeys = Object.keys(rightGridData).sort();

worksheet.push([
  "Rebate Program Cd",
  "Quarter",
  "Subtitle",
  "Description",
  "Record_Count",
]);

let grandTotal = 0;

// Collect all rows first
let allRows = [];

rebateKeys.forEach((rebateKey) => {
  const leftList = leftGridData[rebateKey] || [];
  let currentSubtitle = '';

  leftList.forEach((item) => {
    // Subtitle row → do not write
    if (item.head === true) {
      currentSubtitle = item.title;
      return;
    }

    const count = Number(item.recordCount) || 0;
    grandTotal += count;

    worksheet.push([
      rebateKey,           
      headerData.qtr,       
      currentSubtitle,      
      item.title || '',     
      count.toLocaleString('en-US'),
    ]);
  });
});

allRows.forEach((row) => {
  worksheet.push([
    row.rebateKey,
    row.qtr,

  ]);
});

// Grand total row
worksheet.push([
  "",
  "",
  "",
  "Grand Total:",
  grandTotal.toLocaleString("en-US"),
]);



  // ------------------------
  // WORKBOOK
  // ------------------------
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(worksheet);
  XLSX.utils.book_append_sheet(wb, ws, fileName);

  const finalFilename = fileName ? `${fileName}.xlsx` : 'QuarterlyClaimReconciliation.xlsx';
  XLSX.writeFile(wb, finalFilename);
};
